(function init() {
  angular.module('app').controller('host.views.debugTools.deleteMemberUtilization.modal', [
    '$uibModalInstance',
    'abp.services.app.debugTool',
    function controller($uibModalInstance, debugToolSvc) {
      const vm = this;
      vm.saving = 0;
      vm.type = 0;
      vm.pageState = 0;
      vm.record = {
        memberClaim: null,
        memberUtilizationsJson: [],
        isDeleted: false,
        deleterName: null,
      };
      vm.isOpen = 1;
      vm.showMemberClaim = true;
      vm.id = null;

      vm.back = back;
      vm.cancel = cancel;
      vm.confirm = confirm;
      vm.getRecords = getRecords;

      function back() {
        vm.id = null;
        vm.pageState = 0;
        vm.record = {
          memberClaim: null,
          memberUtilizationsJson: [],
          isDeleted: false,
          deleterName: null,
        };
      }

      function cancel() {
        $uibModalInstance.dismiss();
      }

      function confirm() {
        const deleteWarningMessage =
          vm.type === 0
            ? 'The following member utilization will be deleted. This action cannot be undone.'
            : 'The following member claim and all associated member utilizations will be deleted. This action cannot be undone.';

        abp.message.confirm(deleteWarningMessage, 'Are you sure?', (d) => {
          if (d) {
            vm.memberUtilizationId = vm.type === 0 ? vm.id : null;
            vm.memberClaimId = vm.type === 1 ? vm.id : null;
            
            vm.saving += 1;
            debugToolSvc
              .deleteMemberUtilizationOrMemberClaim({
                memberUtilizationId: vm.memberUtilizationId,
                memberClaimId: vm.memberClaimId,
              })
              .success(() => {
                abp.notify.success('Successfully deleted.');
                vm.saving -= 1;
                $uibModalInstance.dismiss();
              });
          }
        });
      }

      function getRecords() {
        vm.pageState = 1;

        vm.loading += 1;

        const memberUtilizationId = vm.type === 0 ? vm.id : null;
        const memberClaimId = vm.type === 1 ? vm.id : null;

        debugToolSvc
          .getMemberUtilizationRelatedRecords({
            memberUtilizationId,
            memberClaimId,
          })
          .success((data) => {
            vm.record.memberClaimJson = JSON.parse(data.memberClaimJson);
            _.forEach(data.memberUtilizationsJson, (d) => {
              vm.record.memberUtilizationsJson.push(JSON.parse(d)[0]);
            });
            vm.record.isDeleted = data.isDeleted;
            vm.record.deleterName = data.deleterName;
          })
          .finally(() => {
            vm.loading -= 1;
          });
      }
    },
  ]);
})();
